import { render, staticRenderFns } from "./SkillSave.vue?vue&type=template&id=555a1439&scoped=true"
import script from "./SkillSave.vue?vue&type=script&lang=js"
export * from "./SkillSave.vue?vue&type=script&lang=js"
import style0 from "./SkillSave.vue?vue&type=style&index=0&id=555a1439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555a1439",
  null
  
)

export default component.exports